import { SAVE_STATE, REMOVE_STATE } from './ActionTypes';

export const saveState = (state) => ({type : SAVE_STATE, state : state});
export const removeState = () => ({ type : REMOVE_STATE });



// WEBPACK FOOTER //
// ./src/actions/SaveStateAction.js